import { useEffect, useState } from 'react';
import { KTSVG } from '../../../../_metronic/helpers';
import { TeamMember } from '../models/UserTeamModel'
import { useConfirmAction } from '../../../hooks/utils/useConfirmAction';

type Props = {
    user:TeamMember;
    onActive: (user:TeamMember,isActive:boolean) => void;
    onEdit: () => void;
    onDelete: (user:TeamMember) => void;
}

export function UserTeamCardItem({ user, onActive, onEdit, onDelete }: Props) {
    const confirm = useConfirmAction();
    const isUserActive = Boolean(user?.active ?? user?.isActive ?? user?.userData?.active);
    const [ isActive, setIsActive ] = useState(isUserActive);

    useEffect(() => {
        setIsActive(Boolean(user?.active ?? user?.isActive ?? user?.userData?.active));
    }, [user?.id, user?.active, user?.isActive, user?.userData?.active]);

    const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const nextActive = e.target.checked;
        const isUpdate = await confirm({
            title: `${nextActive ? 'Activate' : 'Deactivate'} account`,
            message: `Do you want to ${nextActive ? 'activate' : 'deactivate'} this user?`
        });
        if (isUpdate) {
            setIsActive(nextActive);
            await onActive(user, nextActive);
        } else {
            setIsActive(!nextActive);
        }
    };

    const handleDelete = async () => {
        let isUpdate = await confirm({ title: `Delete account`, message: `Do you want to delete this user?` });
        if(isUpdate){
            onDelete(user)
        }
    }

    return (
        <div className="team-card">
            <div className="team-card-header">
                <div className="team-card-info">
                    <div className="team-card-name">{user?.userData?.firstName} {user?.userData?.lastName}</div>
                    <div className="team-card-meta">
                        <span>{user?.userData?.email}</span>
                        <span>|</span>
                        <span>{user.phoneNumber}</span>
                        <span>|</span>
                        <span>{user?.relation || ''}</span>
                        <span>|</span>
                        <span>{user?.organization || ''}</span>
                    </div>
                </div>
                <label className="input-switch">
                    <input type="checkbox" checked={isActive} onChange={handleChange} />
                    <span className="slider" />
                </label>
            </div>

            <div className="team-card-footer">
                <div className="team-card-assignment">
                    Assignment: {(user.userRoles || []).map((role) => role.name).join(', ')}
                </div>

                <div className="team-card-actions">
                    <div className="icon-edit" onClick={onEdit}>
                        <KTSVG path='/media/svg/nobilis/edit_lg.svg' />
                    </div>
                    <div className="icon-remove" onClick={handleDelete}>
                        <KTSVG path='/media/svg/nobilis/remove-item.svg' />
                    </div>
                </div>
            </div>
        </div>
    );
}